import './BeAnOwnerFormStepper/BeAnOwnerFormStepper.scss';
import BeAnOwnerFormStepper from './BeAnOwnerFormStepper/BeAnOwnerFormStepper';
import { connect } from 'react-redux';
import { UrbainUser } from '../../../redux/user/user.types';
import { useEffect, useState } from 'react';
import './styles.scss';
import $ from 'jquery';
import { sanityClient } from '../../../sanity.io/config';
import SanitySubHeader from '../../atoms/Sanity/SanitySubHeader/SanitySubHeader';
import SanityBody from '../../atoms/Sanity/SanityBody/SanityBody';
import HolidayLikeALocalCard from '../HolidayLikeALocal/HolidayLikeALocalCard/HolidayLikeALocalCard';
import useGet from '../../../services/useGet';
import { Response } from '../../../types/response';
interface NewBeAnOwnerProps {
  urbainUser: UrbainUser;
}

function NewBeAnOwner({ urbainUser }: NewBeAnOwnerProps) {
  const [step, setStep] = useState(1);
  const [data, setData] = useState<any>();

  const [metros, getAllMetros] = useGet<Response>({
    url: '/beanownermetros',
    defaultValue: {}
  });

  useEffect(() => {
    getAllMetros();
    sanityClient.fetch<any>(`*[ _type== "news" && slug.current == "list-your-home"]`).then(response => {
      if (response && response[0]) {
        setData(response[0]);
      }
    });
    var $window = $(window);
    var $videoWrap = $('.video-wrap');
    var $video = $('.video');
    // @ts-ignore
    var videoHeight = $video.innerWidth() * 0.5; //$video.outerHeight();

    $window.on('scroll', function () {
      var windowScrollTop = $window.scrollTop();
      // @ts-ignore
      var videoBottom = videoHeight + $videoWrap.offset().top;

      // @ts-ignore
      if (windowScrollTop > videoBottom && window.outerWidth > 992) {
        // @ts-ignore
        $videoWrap.height(videoHeight);
        $video.addClass('stuck');
      } else {
        $videoWrap.height('auto');
        $video.removeClass('stuck');
      }
    });
  }, []);

  return (
    <div className="flex parent-div-stepper mb-5">
      <div className="row mr-0">
        <div className={'col-lg-8 col-sm-12 pr-0'}>
          <div className="position-relative video-wrap test-wrap">
            <div className="video">
              <iframe
                src="https://player.vimeo.com/video/487383293?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;muted=1&amp;texttrack=en"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; "
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                title="Urbain - Stay Delighted"
              ></iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
          <div className={'container'}>
            <div className={'p-2 m-2'}>
              <div className={'be-an-owner-header'}>
                <SanitySubHeader subHeader={data?.header} />
              </div>
              <SanityBody body={data?.headerParagraph} />
            </div>
          </div>
        </div>
        <div className={'col-lg-4 item stepper col-sm-12 mb-sm-5'}>
          <BeAnOwnerFormStepper urbainUser={urbainUser} step={step} setStep={setStep} metros={metros} />
        </div>
        <div className={'col-lg-8 col-sm-12'}>
          <div className={'container'}>
            <div className={'d-sm-flex flex-column'}>
              {!!data &&
                data?.newsItems?.map((item: any, index: number) => (
                  <HolidayLikeALocalCard key={index} text={item.detail} image={item?.image} imageHeader={item?.title} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  urbainUser: state.user.urbainUser
});

export default connect(mapStateToProps)(NewBeAnOwner);
